import React from "react";

import * as Styled from "./LargeButton.styles";
import { vars } from "../../styles";
import Paragraph from "../Paragraph/Paragraph";

export interface Props {
  image: string;
  title: string;
  subtitle?: string;
  onClick: () => void;
  small?: boolean;
  /// Defaults to "pointer" - pass "default" for a card that doesn't actually do anything on click
  /// (e.g. one that's purely informational), so the cursor doesn't falsely suggest it's clickable.
  cursor?: "pointer" | "default";
}

export default function LargeButton({ image, title, subtitle, onClick, small, cursor }: Props) {
  return (
    <Styled.LargeButton
      onClick={onClick}
      $small={small}
      $cursor={cursor}
    >
      <Styled.ButtonImage src={image} />
      <Paragraph color={vars.colors.grey30}>{title}</Paragraph>
      {subtitle && (
        <Paragraph
          marginTop={4}
          fontSize={14}
        >
          {subtitle}
        </Paragraph>
      )}
    </Styled.LargeButton>
  );
}
